import React, { useState } from 'react';
import { Eye, EyeSlash } from '@phosphor-icons/react';

/**
 * Password input with a show/hide eye. Shared by sign-in and sign-up — sign-up
 * has two of these and typing a password you can't see twice is where people
 * get stuck.
 *
 * The toggle is a <button type="button"> so it can never submit the form, and
 * it's excluded from the tab order: tabbing out of the password should reach
 * Sign In, not the eye.
 */
export default function PasswordField({ value, onChange, placeholder, autoComplete, autoFocus }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="pwf">
      <input
        className="lfi"
        type={shown ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
      />
      <button
        type="button"
        className="pwf-eye"
        onClick={() => setShown((s) => !s)}
        tabIndex={-1}
        aria-label={shown ? 'Hide password' : 'Show password'}
        title={shown ? 'Hide password' : 'Show password'}
      >
        {shown ? <EyeSlash size={18} weight="duotone" /> : <Eye size={18} weight="duotone" />}
      </button>
    </div>
  );
}
